import * as React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import { Land, LandState } from 'src/@types'
import CircularProgressWithLabel from '../utils'
import { Box, Button, Typography } from '@mui/material'
import Translations from 'src/@core/layouts/components/Translations'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import { useRouter } from 'next/router'

interface LoadCardProps {
  land: Land
}

export default function LoadCard({ land }: LoadCardProps) {
  const [percentage, setPercentage] = React.useState<number>(0)
  const router = useRouter()

  React.useEffect(() => {
    if (land.state === LandState.DRAFT_FIELDS) {
      setPercentage(25)
    } else if (land.state === LandState.DRAFT_PLUVIOMETERS) {
      setPercentage(50)
    } else if (land.state === LandState.DRAFT_WATER_TROUGHS) {
      setPercentage(75)
    } else if (land.state === LandState.COMPLETED) {
      setPercentage(100)
    }
  }, [land.state])

  const handleClick = () => {
    if (land.state !== LandState.COMPLETED) router.push(`/create-land/${land.operationUnit?.id}?landId=${land.id}`)
    if (land.state === LandState.COMPLETED) router.push(`/lands/details/land/${land.id}`)
  }

  return (
    <Card
      className='load-card'
      sx={{
        minWidth: '250px',
        height: '260px',
        alignItems: 'center',
        borderRadius: '20px',
        backgroundColor: 'white',
      }}
    >
      <CardContent
        className='card-medio'
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
          }}
        >
          <Typography
            sx={{ fontSize: '18px', fontWeight: '700', color: 'black', textAlign: 'center' }}
            className='cards-title'
          >
            <Translations text={'Data upload'} />
          </Typography>
          <Box
            className='steps-del-campo'
            sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              height: '145px',
              justifyContent: 'space-around',
              alignItems: 'center'
            }}
          >
            <CircularProgressWithLabel value={percentage} />
            <Box sx={{ display: 'flex', flexDirection: 'column', width: '45%' }}>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                {land.state === LandState.DRAFT_FIELDS ||
                  land.state === LandState.DRAFT_PLUVIOMETERS ||
                  land.state === LandState.DRAFT_WATER_TROUGHS ||
                  land.state === LandState.COMPLETED ? (
                  <CheckCircleOutlineIcon sx={{ color: '#213D36', fontSize: '16px', mr: '14px' }} />
                ) : (
                  <RemoveCircleOutlineIcon sx={{ fontSize: '16px', mr: '14px' }} />
                )}
                <Typography sx={{ fontSize: '14px', fontWeight: '400', m: 1, color: 'black' }}>
                  <Translations text={'Land'} />
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                {land.state === LandState.DRAFT_PLUVIOMETERS ||
                  land.state === LandState.DRAFT_WATER_TROUGHS ||
                  land.state === LandState.COMPLETED ? (
                  <CheckCircleOutlineIcon sx={{ color: '#213D36', fontSize: '16px', mr: '14px' }} />
                ) : (
                  <RemoveCircleOutlineIcon sx={{ fontSize: '16px', mr: '14px' }} />
                )}
                <Typography sx={{ fontSize: '14px', fontWeight: '400', m: 1, color: 'black' }}>
                  <Translations text={'Field'} />
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                {land.state === LandState.DRAFT_WATER_TROUGHS || land.state === LandState.COMPLETED ? (
                  <CheckCircleOutlineIcon sx={{ color: '#213D36', fontSize: '16px', mr: '14px' }} />
                ) : (
                  <RemoveCircleOutlineIcon sx={{ fontSize: '16px', mr: '14px' }} />
                )}
                <Typography sx={{ fontSize: '14px', fontWeight: '400', m: 1, color: 'black' }}>
                  <Translations text={'Pluviometers'} />
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                {land.state === LandState.COMPLETED ? (
                  <CheckCircleOutlineIcon sx={{ color: '#213D36', fontSize: '16px', mr: '14px' }} />
                ) : (
                  <RemoveCircleOutlineIcon sx={{ fontSize: '16px', mr: '14px' }} />
                )}
                <Typography sx={{ fontSize: '14px', fontWeight: '400', m: 1, color: 'black' }}>
                  <Translations text={'Water troughs'} />
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', w: '100%', alignItems: 'center', mt: 'auto' }}>
            <Button
              variant='outlined'
              sx={{
                color: '#213D36',
                width: '123px',
                padding: '8px, 12px, 8px, 12px',
                fontSize: '16px',
                fontWeight: 700,
                borderRadius: '30px',
                border: '3px solid #213D36',
                mt: 'auto'
              }}
              onClick={handleClick}
            >
              <Translations text={`${land.state === LandState.COMPLETED ? 'DETAILS' : 'UPLOAD'}`} />
            </Button>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}
